import { getApiUrlPath } from "../../../constant";
import { GenericService } from "../../../shared";
import { IProductCatalogRequest, IProductCatalogResponse } from "./type";

export class ProductCatalogFactory extends GenericService<
  IProductCatalogRequest,
  IProductCatalogResponse
> {
  constructor() {
    super({
      prefix: getApiUrlPath("ProductCatalog"),
    });
  }
}
